import PropTypes from 'prop-types';
// @mui
import Box from '@mui/material/Box';
//
import UserCard from './system-card';

// ----------------------------------------------------------------------

export default function SystemCardList({ users }) {
  return (
    <Box
      gap={3}
      display="grid"
      gridTemplateColumns={{
        xs: 'repeat(1, 1fr)',
        sm: 'repeat(2, 1fr)',
        md: 'repeat(3, 1fr)',
      }}
    >
      {users.map((user) => (
        <UserCard key={user.id} user={user} />
      ))}
    </Box>
  );
}

SystemCardList.propTypes = {
  users: PropTypes.array,
};
